import { useAtomValue } from 'jotai';
import { isTranslatedAtom, translationResultAtom } from './atoms';
import ViewContent from './ViewContent';
import { BodySlotRoot } from './styles';
import type { ApprovalViewData } from './types';

/** 본문 영역 (HTML 본문 + 유형별 슬롯 + showImagesBelowContent 이미지 그리드) */

type BodySlotProps = {
  data: ApprovalViewData;
};

const BodySlot = ({ data }: BodySlotProps) => {
  const isTranslated = useAtomValue(isTranslatedAtom);
  const translationResult = useAtomValue(translationResultAtom);
  const displayedContent =
    isTranslated && translationResult
      ? translationResult.translatedContent
      : data.content;

  return (
    <BodySlotRoot>
      <ViewContent
        apvType={data.type.code}
        documentId={data.documentId}
        content={displayedContent}
        attributes={data.attributes}
        showImagesBelowContent={data.showImagesBelowContent}
        attachments={data.attachments}
      />
    </BodySlotRoot>
  );
};

export default BodySlot;
